import TemporaryVehicle from './vehicle'
export default TemporaryVehicle
